module.exports = "https://static.wanderu.com/ui-react/_next/static/media/ferry-grey.9190f992.svg";